import React, { Fragment, FC } from "react";
import UserLink from "../../../utils/UserLink";
import { useDropClose } from "../../../hooks";
import { connect } from "react-redux";
import { likeSong, toAdd } from "../../../store/actions/track";
import { nextSong, prevSong } from "../../../store/actions/audio";
import { addToQue, clearQue } from "../../../store/actions/queue";
import { Track } from "../../../models/track";

interface Props {
  track: Track;
  toAdd: Function;
  addToQue: Function;

  clearQue: Function;
  prevSong: Function;
  nextSong: Function;
}

const PlayerTrack: FC<Props> = ({
  track,
  toAdd,
  addToQue,
  nextSong,
  prevSong,
  clearQue,
}) => {
  const { id, username } = track;
  useDropClose();

  return (
    <div
      className="player-track-options"
      uk-dropdown="pos: top-right; mode: click;delay-hide: 100"
    >
      <ul className="uk-nav uk-dropdown-nav">
        {track.src && (
          <Fragment>
            <li
              onClick={() => {
                if (id) likeSong(id);
              }}
            >
              <span>Like</span>
            </li>
            <li>
              <span>Share</span>
            </li>
            <li className="uk-nav-divider"></li>
            <li onClick={() => nextSong()}>
              <span>Next</span>
            </li>
            <li onClick={() => prevSong()}>
              <span>Prev</span>
            </li>
            <li className="uk-nav-divider"></li>
            <li uk-toggle="target: #lyrics">
              <span>View lyrics</span>
            </li>
            {username && (
              <li>
                <UserLink params={{ username }}>
                  <span>View artist</span>
                </UserLink>
              </li>
            )}

            <li className="uk-nav-divider"></li>
            <li
              uk-toggle="target: #playlists-modal"
              onClick={() => {
                toAdd(track);
              }}
            >
              <span>Add to playlist</span>
            </li>
            <li
              onClick={() => {
                addToQue(track);
              }}
            >
              <span>Add to Que</span>
            </li>
            <li className="uk-nav-divider"></li>
          </Fragment>
        )}

        <li onClick={() => clearQue()}>
          <span>Clear que</span>
        </li>
        <li uk-toggle="target: #que-view">
          <span>View Que</span>
        </li>
      </ul>
    </div>
  );
};

const mapDispatchToProps = {
  toAdd,
  addToQue,
  nextSong,
  prevSong,
  clearQue,
};

export default connect(null, mapDispatchToProps)(PlayerTrack);
